module.exports = __webpack_public_path__ + "img/product.4da31b35.png";